import { HelpContent } from '../../../../UI-Lib/Help-Tooltip';

export const ASSET_ADVANCED_HELP: HelpContent[] = [
    {
        helpContentId: 'asset-advanced.header',
        tooltipText: 'Advanced'
    }
];
